import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from 'lib/utils'
import * as React from 'react'

const textareaVariants = cva(
  'flex field-sizing-content min-h-16 w-full transition-[color,box-shadow] outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
  {
    variants: {
      variant: {
        default:
          'rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-xs placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:bg-input/30 dark:aria-invalid:ring-destructive/40',
        // T3 dual-theme textarea — paper text on bg-3, hairline border that
        // turns acid on focus. No soft halo (matches ComposerRow spec). The
        // `!` on focus:border-primary is required to beat the layer-less
        // .border-line-bright shim in design-system.css.
        dark: 'rounded-[10px] border border-line-bright bg-bg-3 px-4 py-3 text-[15px] text-paper transition-[border-color] placeholder:text-paper-faint focus:border-primary!',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

function Textarea({
  className,
  variant,
  ...props
}: React.ComponentProps<'textarea'> & VariantProps<typeof textareaVariants>) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(textareaVariants({ variant }), className)}
      {...props}
    />
  )
}

export { Textarea }
